import { lazy } from 'react';

import { withBottomNav } from '@perpay-web/components/higher-order/WithBottomNav/WithBottomNav';
import { withLoader } from '@perpay-web/components/higher-order/WithLoader/WithLoader';
import { withPerpayTitle } from '@perpay-web/components/higher-order/WithPerpayTitle/WithPerpayTitle';
import PaychexLoginFormContainer from '@perpay-web/fintech/components/composite/PaychexOnboarding/PaychexLoginFormContainer';
import BorrowerLogoutContainer from '@perpay-web/fintech/components/containers/BorrowerLogoutContainer';
import BorrowerResetPasswordContainer from '@perpay-web/fintech/components/containers/BorrowerResetPasswordContainer';
import LoginFormContainer from '@perpay-web/fintech/components/containers/LoginFormContainer';
import MFAContainer from '@perpay-web/fintech/components/containers/MFAContainer';
import { withLoginRedirectCheck } from '@perpay-web/fintech/components/higher-order/WithLoginRedirectCheck/WithLoginRedirectCheck';
import { withLoginRedirectPath } from '@perpay-web/fintech/components/higher-order/WithLoginRedirectPath/WithLoginRedirectPath';
import { withSignupRedirectCheck } from '@perpay-web/fintech/components/higher-order/WithSignupRedirectCheck/WithSignupRedirectCheck';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { importBorrowerLoginContainer } from '@perpay-web/fintech/utils/imports/importBorrowerLoginContainer';
import { importBorrowerSignup } from '@perpay-web/fintech/utils/imports/importBorrowerSignup';
import { importMarketplacePartnerOnboardingSignupContainer } from '@perpay-web/fintech/utils/imports/importMarketplacePartnerOnboardingSignupContainer';
import { importPartnerOnboardingSignupContainer } from '@perpay-web/fintech/utils/imports/importPartnerOnboardingSignupContainer';
import { importPaychexConfirmEmployerContainer } from '@perpay-web/fintech/utils/imports/importPaychexConfirmEmployerContainer';
import { importPaychexContinueContainer } from '@perpay-web/fintech/utils/imports/importPaychexContinueContainer';
import { importPaychexOnboardingError } from '@perpay-web/fintech/utils/imports/importPaychexOnboardingError';
import { importPaychexOnboardingSignUpContainer } from '@perpay-web/fintech/utils/imports/importPaychexOnboardingSignUpContainer';
import { importPaychexSSORedirectContainer } from '@perpay-web/fintech/utils/imports/importPaychexSSORedirect';
import { compose } from '@perpay-web/utils/functionalUtils';

const EmptyBottomNav = () => null;
const BorrowerLoginRoute = compose(
    withPerpayTitle('Login'),
    withLoginRedirectCheck,
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importBorrowerLoginContainer)));
const PartnerSignupRoute = compose(
    withPerpayTitle('Sign up'),
    withLoginRedirectCheck,
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importPartnerOnboardingSignupContainer)));
const MarketplacePartnerSignupRoute = compose(
    withPerpayTitle('Sign up'),
    withLoginRedirectCheck,
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importMarketplacePartnerOnboardingSignupContainer)));

const PaychexSignupRoute = compose(
    withPerpayTitle('Sign up'),
    withLoginRedirectPath(paths.paychexSSORedirect.path),
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importPaychexOnboardingSignUpContainer)));

const identity = (x) => x;

const BorrowerSignupRoute = compose(
    withPerpayTitle('Sign up'),
    withSignupRedirectCheck,
    withBottomNav(EmptyBottomNav),
    identity,
)(withLoader(lazy(importBorrowerSignup)));

const PaychexContinueRoute = compose(
    withPerpayTitle('Paychex Continue'),
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importPaychexContinueContainer)));

const PaychexConfirmEmployerRoute = compose(
    withPerpayTitle('Paychex Confirm Employer'),
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importPaychexConfirmEmployerContainer)));

const PaychexSSORedirectRoute = compose(
    withPerpayTitle('Paychex Login'),
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importPaychexSSORedirectContainer)));

const PaychexLoginRoute = compose(
    withPerpayTitle('Login'),
    withBottomNav(EmptyBottomNav),
)(PaychexLoginFormContainer);

const PaychexErrorRoute = compose(
    withPerpayTitle('Paychex Error'),
    withBottomNav(EmptyBottomNav),
)(withLoader(lazy(importPaychexOnboardingError)));
/**
 * @type {import('react-router').RouteObject[]}
 */
export const authenticatingRoutes = [
    { path: paths.signUp.path, element: <BorrowerSignupRoute /> },
    {
        path: paths.login.path,
        element: <BorrowerLoginRoute />,
        children: [
            {
                index: true,
                element: <LoginFormContainer />,
            },
            {
                path: paths.resetPassword.path,
                element: <BorrowerResetPasswordContainer />,
            },
            {
                path: paths.mfa.path,
                element: <MFAContainer />,
            },
        ],
    },
    { path: paths.logout.path, element: <BorrowerLogoutContainer /> },
    {
        path: paths.partnerOnboardingInvitation.path,
        element: <PartnerSignupRoute />,
    },
    {
        path: paths.marketplacePartnerOnboardingInvitation.path,
        element: <MarketplacePartnerSignupRoute />,
    },
    {
        path: paths.paychexSignup.path,
        element: <PaychexSignupRoute />,
    },
    {
        path: paths.paychexLogin.path,
        element: <PaychexLoginRoute />,
    },
    {
        path: paths.paychexSSORedirect.path,
        element: <PaychexSSORedirectRoute />,
    },
    {
        path: paths.paychexError.path,
        element: <PaychexErrorRoute />,
    },
    {
        path: paths.paychexSSOContinue.path,
        element: <PaychexContinueRoute />,
    },
    {
        path: paths.paychexConfirmEmployer.path,
        element: <PaychexConfirmEmployerRoute />,
    },
];
